var path = 'areas/shared/views/interrupt-fields/interrupt_Paragraph.html';
var html = "<markdown text=element.properties.Text />";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/interrupt-fields/interrupt_Paragraph.html
// module id = 965
// module chunks = 1